const c = {
  name: "KenyanShilling",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,14h2v4.8l1.6-1c0.3-0.2,0.4-0.5,0.4-0.8V14h2v2.9c0,1-0.5,1.9-1.3,2.5L13.8,20l0.9,0.6
			c0.8,0.6,1.3,1.5,1.3,2.5V26h-2v-2.9c0-0.3-0.2-0.6-0.4-0.8l0,0l-1.6-1V26h-2V14z"/>
		<path class="st0" d="M19,17c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v1h2v-1c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v0.8c0,1.1,0.6,2.2,1.7,2.7
			l1.8,0.9c0.3,0.2,0.6,0.5,0.6,0.9V23c0,0.5-0.5,1-1,1c-0.5,0-1-0.5-1-1v-1h-2v1c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3v-0.8
			c0-1.1-0.6-2.2-1.7-2.7l-1.8-0.9c-0.3-0.2-0.6-0.5-0.6-0.9V17z"/>
		<path class="st0" d="M26,22v4h-2V14h2v5.2c0.3-0.1,0.6-0.2,1-0.2c1.7,0,3,1.3,3,3v4h-2v-4c0-0.5-0.5-1-1-1C26.5,21,26,21.5,26,22z
			"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as KenyanShilling
};
